(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["viviero-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('viviero-new-arrivals')) {
    customElements.define('viviero-new-arrivals', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-vna-track]');
        this.items = [...this.querySelectorAll('[data-vna-item]')];
        if (!this.track || !this.items.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.controls = this.querySelector('[data-vna-controls]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.interacting = false;
        this.keyboardFocused = false;
        this.interval = Math.max(4000, Number(this.dataset.interval) || 6000);
        this.querySelector('[data-vna-prev]').addEventListener('click', () => { this.move(-1); this.schedule(); }, { signal });
        this.querySelector('[data-vna-next]').addEventListener('click', () => { this.move(1); this.schedule(); }, { signal });
        this.addEventListener('pointerdown', () => {
          this.interacting = true;
          this.keyboardFocused = false;
          this.schedule();
        }, { signal, passive:true });
        const finishInteraction = () => {
          if (!this.interacting) return;
          this.interacting = false;
          this.schedule();
        };
        document.addEventListener('pointerup', finishInteraction, { signal, passive:true });
        document.addEventListener('pointercancel', finishInteraction, { signal, passive:true });
        this.addEventListener('focusin', event => {
          this.keyboardFocused = event.target.matches(':focus-visible');
          this.schedule();
        }, { signal });
        this.addEventListener('focusout', event => {
          if (this.contains(event.relatedTarget)) return;
          this.keyboardFocused = false;
          this.schedule();
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        this.track.addEventListener('scroll', () => this.updatePosition(), { signal, passive:true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.motion.addEventListener('change', () => this.schedule(), { signal });
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold:0.15 });
        this.visibilityObserver.observe(this);
        this.resizeObserver = new ResizeObserver(() => { this.updatePosition(); this.schedule(); });
        this.resizeObserver.observe(this.track);
        this.dataset.ready = 'true';
        this.updatePosition();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.controller?.abort();
        this.controller = null;
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
      }
      stride() {
        return this.items[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      }
      move(direction) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max < 2) return;
        const current = this.track.scrollLeft;
        let target = Math.round(current / this.stride()) * this.stride() + direction * this.stride();
        if (direction > 0 && current >= max - 3) target = 0;
        if (direction < 0 && current <= 3) target = max;
        this.track.scrollTo({ left:Math.max(0, Math.min(max, target)), behavior:this.motion.matches ? 'instant' : 'smooth' });
      }
      updatePosition() {
        const total = this.items.length;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const shown = Math.min(total, Math.max(1, Math.round(this.track.clientWidth / this.stride())));
        const start = Math.min(total - shown, Math.max(0, Math.round(this.track.scrollLeft / this.stride())));
        this.controls.hidden = max < 2;
        const progress = this.querySelector('[data-vna-progress]');
        progress.style.width = `${shown / total * 100}%`;
        progress.style.transform = `translateX(${start / shown * 100}%)`;
      }
      schedule() {
        clearInterval(this.timer);
        if (this.dataset.autoplay !== 'true' || this.motion.matches || this.interacting || this.keyboardFocused || !this.visible || document.hidden || this.track.scrollWidth <= this.track.clientWidth + 2) return;
        this.timer = setInterval(() => this.move(1), this.interval);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
